import { render, staticRenderFns } from "./societyOneList.vue?vue&type=template&id=50de99d8&scoped=true"
import script from "./societyOneList.vue?vue&type=script&lang=js"
export * from "./societyOneList.vue?vue&type=script&lang=js"
import style0 from "./societyOneList.vue?vue&type=style&index=0&id=50de99d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50de99d8",
  null
  
)

export default component.exports